import {AbstractVisualFeature} from '../../visual-feature.js';
import {StaticPages} from '../static-pages.js';

import {maintenanceFactory} from './maintenance.factory.js';

import PALETTE_SCHEMA from './maintenance.palette-schema.yaml';

class MaintenanceFeature extends AbstractVisualFeature {
    get name() {
        return 'maintenance';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return maintenanceFactory(PALETTE);
    }
}

new MaintenanceFeature(StaticPages);
